/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Extension_Tracker_Trackedbelowthreshold2Inputs */

const he_extension_tracker_trackedbelowthreshold2 = /** @type {(inputs: Extension_Tracker_Trackedbelowthreshold2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`במעקב ב-PriceDrop: מתחת ל-₪${i?.amount}`)
};

const en_extension_tracker_trackedbelowthreshold2 = /** @type {(inputs: Extension_Tracker_Trackedbelowthreshold2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tracked on PriceDrop: below ₪${i?.amount}`)
};

/**
* | output |
* | --- |
* | "Tracked on PriceDrop: below ₪{amount}" |
*
* @param {Extension_Tracker_Trackedbelowthreshold2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_tracker_trackedbelowthreshold2 = /** @type {((inputs: Extension_Tracker_Trackedbelowthreshold2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_Trackedbelowthreshold2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_trackedbelowthreshold2(inputs)
	return en_extension_tracker_trackedbelowthreshold2(inputs)
});
export { extension_tracker_trackedbelowthreshold2 as "extension_tracker_trackedBelowThreshold" }